export enum ItemCompletedFlag {
	COMPLETED = 1,
	NOT_COMPLETED = 0,
	BOTH = 2,
}
